import React from "react";
import { Link, useLocation } from "react-router-dom";
export default function Footer() {
    const location = useLocation();
    return (
        <footer className="footer">
            <div className="footer-container">
                <div className="footer-col">
                    <h3>About Us</h3>
                    <p>Founded in 2024 by Basha G. in Tirupur, India’s renowned clothing hub, to DoWhile Clothing was born with a simple yet powerful mission: to make high-quality kids' clothing accessible to everyone at a price that doesn’t break the bank.</p>
                </div>
                <div className="footer-col">
                    <h4>Explore</h4>
                    <ul>
                        <li>Orders</li>
                        <li>Profile</li>
                    </ul>
                </div>
                <div className="footer-col">
                    <h4>Quick Links</h4>
                    <ul>
                        <li>Privacy Policy</li>
                        <li>Return Policy</li>
                        <li>Terms & Condition</li>
                        <li>About Us</li>
                    </ul>
                </div>
                <div className="footer-col">
                    <h4>Products</h4>
                    <ul>
                        <li>Shop for Kids</li>
                        <li>Kids Inner Wears</li>
                        <li>Shop for Men</li>
                    </ul>
                </div>
            </div>
            <div className="footer-bottom">© {new Date().getFullYear()} Website Developed By{" "}<a href="https://www.praneeshinfotech.com" target="_blank" rel="noopener noreferrer">Praneesh Infotech</a>. All Rights Reserved.</div>
        </footer>
    );
}